export enum statusType {
  ATTACK = 'attack',
  DEFENSE = 'defense',
  CRITICAL = 'critical',
  HP = 'hp',
  MP = 'mp',
  SPEED = 'speed',
  STATUS1 = 'status1',
  STATUS2 = 'status2',
  STATUS3 = 'status3',
  STATUS4 = 'status4',
  STATUS5 = 'status5',
}

export const defaultStatusList = [
  { key: statusType.ATTACK, value: '공격력', isActive: true, type: '전투' },
  { key: statusType.CRITICAL, value: '관통력', isActive: true, type: '전투' },
  { key: statusType.DEFENSE, value: '방어력', isActive: true, type: '전투' },
  { key: statusType.HP, value: '체력', isActive: true, type: '전투' },
  { key: statusType.MP, value: '마력', isActive: true, type: '전투' },
  { key: statusType.SPEED, value: '속도', isActive: true, type: '전투' },
  { key: statusType.STATUS1, value: '매력', isActive: true, type: '커스텀' },
  { key: statusType.STATUS2, value: '솜씨', isActive: true, type: '커스텀' },
  { key: statusType.STATUS3, value: '평판', isActive: true, type: '커스텀' },
  {
    key: statusType.STATUS4,
    value: '마법방어',
    isActive: true,
    type: '커스텀',
  },
  { key: statusType.STATUS5, value: '지식', isActive: true, type: '커스텀' },
];

export interface IstatusItem {
  id: string;
  key: statusType | string;
  value: string;
  statusValue?: number;
  isActive: boolean;
  type: '전투' | '커스텀';
  // 전투타입 스탯의 기본 최대값 (새 캐릭터 생성 시 적용)
  defaultMaxValue?: number;
  // 총 스탯 합산 포함 여부 (미설정 시 포함)
  includeInTotalStat?: boolean;
}

export interface IstatusSet {
  max?: string; // 스탯 맥시멈
  isShow?: boolean;
  isStatusInventoryShow?: boolean;
  isHistoryShow?: boolean;
  useStatusSec?: boolean;
  useSkillSec?: boolean;
  useEquipmentSec?: boolean;
  useConsumableSec?: boolean;
  usePetSec?: boolean;
  // HP/MP 기본 최댓값 (새 캐릭터 생성 시 적용)
  defaultHp?: number;
  defaultMp?: number;
  // 스탯 표시 디자인 타입
  displayType?: 'default' | 'hpmpEmphasized';
  // 총 스탯 표시 on/off (미설정 시 표시)
  showTotalStat?: boolean;
  // 액션바 버튼 on/off (미설정 시 기본 표시)
  isSidePanelShow?: boolean;
  isMusicShow?: boolean;
  isVoiceShow?: boolean;
  isMyRoomShow?: boolean;
  // 마스터 알림 수신 설정 (Firestore 저장 - 모든 유저 디바이스에서 참조)
  masterNotifications?: {
    guestbook?: boolean;
    gift?: boolean;
    chat?: boolean;
  };
}
